module.exports = __webpack_public_path__ + "static/img/logo.7aee24e9.svg";